import React, {useEffect, useRef, useState} from "react";
import {
    Envelope,
    Telephone,
    GeoAlt,
    Eye,
    EyeSlash,
    ArrowRight,
    Shop,
    ShieldCheck,
    Map,
} from "react-bootstrap-icons";

import {useNavigate} from "react-router-dom";

import {decryptData} from "../../utils/crypto";
import Utils from "../../utils";
import {useTranslation} from "react-i18next";
import {
    getCityList,
    getCountryList,
    getStateList,
} from "../../services/commonServices";
import Select from "react-select";
import {createSendOtp, customerSignup} from "../../services/authServices";
import {customStyles} from "../../utils/function";
import {useDispatch} from "react-redux";
import {notify} from "../../components/Common/Alerts";
import {authActions} from "../../store";

const Signup = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const deviceToken = localStorage.getItem("app_fcm_token");
    const deviceType = localStorage.getItem("device_type");

    const {t} = useTranslation();
    const [darkMode, setDarkMode] = useState(
        localStorage.getItem("theme") === "dark",
    );
    const [formData, setFormData] = useState({
        name: "",
        // mobile: "",
        // address: "",
        // landmark: "",
        // city_id: "",
        // state_id: "",
        // country_id: "",
        // pincode: "",
        // latitude: "",
        // longitude: "",
        email: "",
        // confirm_password: "",
        // password: "",
    });
    const [errors, setErrors] = useState({
        mobile: "",
        email: "",
    });
    const [btnLoading, setBtnLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);

    useEffect(() => {
        const handleStorageChange = () => {
            setDarkMode(localStorage.getItem("theme") === "dark");
        };
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    const validateField = (name, value) => {
        switch (name) {
            case "mobile":
                const mobileRegex = /^\d{10}$/;
                if (!mobileRegex.test(value)) {
                    return "Enter a valid 10-digit mobile number";
                }
                return "";

                // case "email":
                //   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                //   if (!emailPattern.test(value)) return "Enter a valid email address";
                //   return "";

                // case "password":
                //   if (!value) return "Password is required";
                //   if (value.length < 6)
                //     return "Password must be at least 6 characters long";
                //   if (!/[a-zA-Z]/.test(value))
                //     return "Password must contain at least one letter";
                //   return "";

                // case "confirm_password":
                //   if (!value) return "Confirm Password is required";
                //   if (value !== formData.password) return "Passwords do not match";

                return "";

            case "name":
                if (!value) return "Name is required";
                return "";

            default:
                return "";
        }
    };
    const handleMobileValidation = () => {
        let errorMsg = "";

        const mobileRegex = /^\d{10}$/;

        if (!formData.mobile) {
            errorMsg = "Mobile is required";
        } else if (!mobileRegex.test(formData.mobile)) {
            errorMsg = "Enter a valid 10-digit mobile number";
        }

        setErrors((prev) => ({
            ...prev,
            mobile: errorMsg,
        }));
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        if (name === "mobile") {
            const cleanedValue = value.replace(/\D/g, "").slice(0, 10);

            setFormData((prev) => ({
                ...prev,
                mobile: cleanedValue,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
        setErrors((prev) => ({
            ...prev,
            [name]: validateField(name, value, {...formData, [name]: value}),
        }));
    };

    useEffect(function () {
        getCountryList()
            .then((response) => {
                const decrypted = decryptData(response.data.data);
                const formatted = decrypted.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setCountryList(formatted);
            })
            .catch((err) => {
                notify.error(Utils.getErrorMessage(err));
            });
    }, []);

    // useEffect(() => {
    //   if (!window.google) return;

    //   const hasSavedLocation = formData?.latitude && formData?.longitude;

    //   const initMap = (lat, lng) => {
    //     const mapInstance = new window.google.maps.Map(
    //       document.getElementById("map"),
    //       {
    //         center: { lat, lng },
    //         zoom: 15,
    //       },
    //     );

    //     const markerInstance = new window.google.maps.Marker({
    //       position: { lat, lng },
    //       map: mapInstance,
    //       draggable: true,
    //     });

    //     setMap(mapInstance);
    //     setMarker(markerInstance);

    //     markerInstance.addListener("dragend", () => {
    //       const pos = markerInstance.getPosition();

    //       const newLat = pos.lat();
    //       const newLng = pos.lng();

    //       setFormData((prev) => ({
    //         ...prev,
    //         latitude: newLat,
    //         longitude: newLng,
    //       }));

    //       getAddressFromLatLng(newLat, newLng);
    //     });
    //   };

    //   if (hasSavedLocation) {
    //     initMap(Number(formData.latitude), Number(formData.longitude));
    //     return;
    //   }

    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(
    //       (position) => {
    //         const lat = position.coords.latitude;
    //         const lng = position.coords.longitude;

    //         setFormData((prev) => ({
    //           ...prev,
    //           latitude: lat,
    //           longitude: lng,
    //         }));

    //         initMap(lat, lng);
    //       },
    //       (error) => {

    //         initMap(23.0225, 72.5714);
    //       },
    //       {
    //         enableHighAccuracy: true,
    //         timeout: 10000,
    //         maximumAge: 0,
    //       },
    //     );
    //   } else {
    //     initMap(23.0225, 72.5714);
    //   }
    // }, [formData?.latitude, formData?.longitude]);

    // const getAddressFromLatLng = (lat, lng) => {
    //   const geocoder = new window.google.maps.Geocoder();

    //   geocoder.geocode({ location: { lat, lng } }, (results, status) => {
    //     if (status === "OK" && results[0]) {
    //       const result = results[0];

    //       let address = result.formatted_address;
    //       let landmark = "";
    //       let pincode = "";

    //       //extract components
    //       result.address_components.forEach((component) => {
    //         const types = component.types;

    //         if (types.includes("postal_code")) {
    //           pincode = component.long_name;
    //         }

    //         if (
    //           types.includes("sublocality_level_1") ||
    //           types.includes("sublocality") ||
    //           types.includes("neighborhood")
    //         ) {
    //           landmark = component.long_name;
    //         }
    //       });

    //       setFormData((prev) => ({
    //         ...prev,
    //         address,
    //         landmark: landmark || prev.landmark,
    //         pincode: pincode || prev.pincode,
    //       }));
    //     }
    //   });
    // };

    // const getLatLngFromAddress = (address) => {
    //   if (!window.google) return;

    //   const geocoder = new window.google.maps.Geocoder();

    //   geocoder.geocode({ address }, (results, status) => {
    //     if (status === "OK" && results[0]) {
    //       const location = results[0].geometry.location;

    //       const lat = location.lat();
    //       const lng = location.lng();

    //       setFormData((prev) => ({
    //         ...prev,
    //         latitude: lat,
    //         longitude: lng,
    //       }));

    //       if (map) {
    //         map.setCenter({ lat, lng });
    //       }

    //       if (marker) {
    //         marker.setPosition({ lat, lng });
    //       }
    //     }
    //   });
    // };

    // useEffect(() => {
    //   if (formData?.country_id) {
    //     let data = {
    //       country_id: formData.country_id,
    //     };

    //     getStateList(data)
    //       .then((response) => {
    //         const decrypted = decryptData(response.data.data);

    //         const formatted = decrypted.data.map((item) => ({
    //           value: item.id,
    //           label: item.name,
    //         }));

    //         setStateList(formatted);
    //       })
    //       .catch((err) => {
    //         notify.error(Utils.getErrorMessage(err));
    //       });
    //   }
    // }, [formData?.country_id]);

    // useEffect(() => {
    //   if (formData?.state_id) {
    //     let data = {
    //       state_id: formData.state_id,
    //     };

    //     getCityList(data)
    //       .then((response) => {
    //         const decrypted = decryptData(response.data.data);

    //         const formatted = decrypted.data.map((item) => ({
    //           value: item.id,
    //           label: item.name,
    //         }));

    //         setCityList(formatted);
    //       })
    //       .catch((err) => {
    //         notify.error(Utils.getErrorMessage(err));
    //       });
    //   }
    // }, [formData?.state_id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {
            name: validateField("name", formData.name),
            mobile: validateField("mobile", formData.mobile),
            // password: validateField("password", formData.password),
        };
        Utils.focusError();
        setErrors(newErrors);
        const hasErrors = Object.values(newErrors).some((err) => err);

        if (hasErrors) return;

        setBtnLoading(true);

        let obj = {
            name: formData.name?.trim() || "",
            mobile: formData.mobile,
            role_id: 3,
        };

        let data = {
            name: formData.name?.trim() || "",
            mobile: formData.mobile,
            device_token: deviceToken,
            device_type: deviceType,
            role_id: 3,
        };

        try {
            const response = await createSendOtp(obj);
            const decrypted = decryptData(response.data.data);
            notify.success(decrypted.message);

            navigate("/otp", {
                state: {data},
                replace: true,
            });
            // Utils.setDetail(decrypted);
            // Utils.setIntervalRemove();
            // dispatch(authActions.login(decrypted));
            // navigate("/dashboard");
            setErrors("");
        } catch (err) {
            notify.error(Utils.getErrorMessage(err));
        } finally {
            setBtnLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#FDFCFB] flex items-center justify-center p-6 lg:p-12 font-sans">
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div
                    className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-orange-500/5 rounded-full blur-[120px]"></div>
                <div
                    className="absolute bottom-[-5%] right-[-5%] w-[400px] h-[400px] bg-blue-600/5 rounded-full blur-[100px]"></div>
            </div>

            <div className="relative z-10 w-full max-w-6xl">
                <section
                    className="bg-white border border-slate-100 rounded-[40px] shadow-[0_20px_50px_rgba(0,0,0,0.05)] overflow-hidden flex flex-col lg:flex-row">
                    <div
                        className="lg:w-1/3 bg-slate-50/50 p-10 flex flex-col items-center justify-between border-r border-slate-100">
                        {/* TOP: Brand Logo */}
                        <div className="w-full">
                            <div
                                className="flex items-center gap-2 mb-8 cursor-pointer hover:opacity-80 transition-all"
                                onClick={() => navigate("/")}
                            >
                                <div
                                    className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center shadow-lg shadow-orange-500/20">
                                    <Shop className="text-white" size={20}/>
                                </div>
                                <span className="text-xl font-black text-slate-800 tracking-tighter">
                  DukaanSetu
                </span>
                            </div>
                        </div>

                        {/* MIDDLE: Branding Text */}
                        <div className="flex flex-col items-center text-center">
                            <h1 className="text-2xl font-black text-slate-800 leading-tight">
                                Join <span className="text-orange-500">DukaanSetu</span> <br/>
                                <span className="text-lg font-bold text-slate-400">
                  Register your store
                </span>
                            </h1>

                            <div className="mt-6 bg-orange-100/50 px-4 py-2 rounded-full flex items-center gap-2">
                                <ShieldCheck className="text-orange-600" size={16}/>
                                <span className="text-[10px] font-bold text-orange-700 uppercase tracking-widest">
                  Verified Platform
                </span>
                            </div>
                        </div>

                        {/* BOTTOM: Login Redirect Button */}
                        <div className="w-full space-y-4 mt-4">
                            <div className="p-6 bg-white border border-slate-100 rounded-[2rem] shadow-sm text-center">
                                <p className="text-sm font-bold text-slate-500 mb-4">
                                    Already have an account?
                                </p>
                                <button
                                    onClick={() => navigate("/login")}
                                    className="w-full bg-slate-900 text-white py-4 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-slate-800 transition-all shadow-xl shadow-slate-200 active:scale-95"
                                >
                                    Login Instead
                                </button>
                            </div>

                            <p className="text-[10px] text-center text-slate-400 font-medium px-4">
                                By continuing, you agree to our{" "}
                                <span
                                    className="underline cursor-pointer"
                                    onClick={() => navigate("/terms-conditions")}
                                >
                  Terms of Service
                </span>{" "}
                                and{" "}
                                <span
                                    className="underline cursor-pointer"
                                    onClick={() => navigate("/privacy-policy")}
                                >
                  Privacy Policy
                </span>
                                .
                            </p>
                        </div>
                    </div>

                    {/* <div className="lg:w-2/3 p-8 lg:p-12 max-h-[85vh] overflow-y-auto"> */}
                    <div className="lg:w-2/3 p-8 lg:p-12">
                        <div className="mb-8">
                            <h2 className="text-xl font-bold text-slate-800 uppercase tracking-tight">
                                Customer Register
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                            <div className="flex flex-col gap-2">
                                <label className="signup-label">
                                    {t("fullName")}
                                    <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300">
                                        <Shop/>
                                    </div>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Enter name"
                                        className={`signup-input-text`}
                                        value={formData?.name || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                                {errors.name && (
                                    <span className="text-danger">{errors.name}</span>
                                )}
                            </div>

                            <div className="flex flex-col gap-2">
                                <label className="signup-label">
                                    {t("mobileNumber")}
                                    <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300">
                                        <Telephone/>
                                    </div>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        name="mobile"
                                        placeholder={t("enterYourMobileNumber")}
                                        className={`signup-input-text ${errors.mobile ? "input-error" : ""}`}
                                        value={formData?.mobile}
                                        onChange={handleChange}
                                        onBlur={handleMobileValidation}
                                        min={0}
                                        onKeyDown={(e) => {
                                            if (["-", "e", "E", "+"].includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                {errors.mobile && (
                                    <span className="text-danger">{errors.mobile}</span>
                                )}
                            </div>

                            <div className="md:col-span-2 pt-6">
                                <button
                                    className="w-full bg-orange-500 hover:bg-orange-600 text-white font-black py-4 rounded-2xl shadow-xl shadow-orange-500/20 transition-all flex items-center justify-center gap-3 group"
                                    onClick={handleSubmit}
                                    disabled={btnLoading}
                                >
                                    {btnLoading ? (
                                        <>
                                            <svg
                                                className="animate-spin h-5 w-5"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                />
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                />
                                            </svg>

                                            <span className="text-lg uppercase">
                        {t("submitting...")}
                      </span>
                                        </>
                                    ) : (
                                        <>
                                            <span className="text-lg uppercase">Create Account</span>

                                            <ArrowRight
                                                className="group-hover:translate-x-1 transition-transform"
                                                size={20}
                                            />
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
export default Signup;
